module.exports = __webpack_public_path__ + "assets/img/RaceType_Harness-BLACK.c0d330cf.svg";